// eslint-disable-next-line import/prefer-default-export

export const blue = '#0123111';
export const dark = '#1F2935';
export const red = '##FFFFFF';
export const gray = '#E6E6E6';
export const aqua = '#22CCE2';
export const menuBorderGray = '#8291A9';
export const menuBackgroundGray = '#EDF4FB';
export const menuItemColor = '#69718d';
